import hackimg from "../assets/hackthisfall.png";
import code from "../assets/code.png";
import hackteam from "../assets/hackteam.png";
import event from "../assets/event.png";
import team from "../assets/bang1.jpeg";
import google from "../assets/google.png";
import grp1 from "../assets/grp1.png";
import grp2 from "../assets/grp2.png";
import grp3 from "../assets/grp3.png";

export const timelineData = [
  {
    title: "Google Developer Graduation Ceremony Banglore",
    date: "13 July, 2024",
    description:
      "The day was really jam-packed with enlightening talks by Googlers, engaging panel discussions, and a pre-event activity that was pretty cool where we had to form teams to take on problem statements. So, our team, Search Party, really had a great time in ideating and presenting the solution.\n\nAnd of course, the event wouldn't have been complete without the fun activities and delicious food because lets be honest, a Google event always has amazing food!",
    images: [team, google],
    icon: event,
    link: "https://www.linkedin.com/posts/manas0609_and-the-year-comes-to-an-end-memories-made-activity-7222611180060635137-KolI?utm_source=share&utm_medium=member_desktop",
    latest: true,
  },
  {
    title: "Hack This Fall S4 Gandhinagar",
    date: "9-11 February, 2024",
    description:
      "We build a website to help and educate farmers with or without Internet, by using Vonage APIs to transform lessons into automated calls, and adding a mentorship program to help users take consultations and advice from agricultural specialists.\n\nThis project aimed to bridge the digital divide in rural farming communities by providing accessible agricultural education through multiple channels.",
    images: [hackimg, hackteam],
    icon: event,
    link: "https://developer.vonage.com/en/blog/hack-this-fall-4-0-winner-and-participants-spotlight",
    latest: false,
  },
  {
    title: "Devfest 2023 Indore",
    date: "26 November 2023",
    description: `I am overwhelmed with gratitude when I reflect on the amazing experience of organizing DevFest 23 Indore at Sayaji Hotels Ltd. Being at the helm of this event was nothing short of a transformative experience. From meticulous team preparation to navigating the complexities of event management, every challenge was met with resilience and collective knowledge.

Thanks to the addition of the Community and Expert Lounges, this DevFest was really unique. An additional layer of connection and learning was added by seeing lively community debates and exploring professional ideas.

A Personal Milestone: This event holds a special place in my heart as I took the stage for the first time as a speaker in the Community Lounge. I shared insights on Making Most out of the Communities.`,
    images: [grp1, grp2, grp3],
    icon: event,
    link: "#",
    latest: false,
  },
];
